// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import TcsmWipContainer from './state-connector';

const TcsmWip = props =>
    props.children || <TcsmWipContainer {...props}/>;

TcsmWip.propTypes = {
    children: PropTypes.node
};

export default TcsmWip;



// WEBPACK FOOTER //
// ./src/tcsm/wip/index.js